<template>
  <div id="factory-model">
    <!-- 左侧工厂树状结构开始 -->
    <div class="left-store-nav">
      <el-scrollbar>
        <span class="table-head">
          <span class="table-head-item table-head-code" style="border-left: none">
            <span class="show-ellipsis">编码</span>
          </span>
          <span class="table-head-item" style="flex: 1.5">
            <span>名称</span>
          </span>
          <span class="table-head-item" style="flex: 0.8">
            <span>资源</span>
          </span>
          <span class="table-head-item" style="flex: 1">
            <span>属性</span>
          </span>
          <span class="table-head-item" style="flex: 1" v-if="permission.btn_factoryModel_updateFactoryModel">
            <span>操作</span>
          </span>
        </span>
        <el-tree
          ref="tree"
          :default-expanded-keys="[selecTree]"
          :indent="10"
          :current-node-key="selecTree"
          node-key="id"
          class="tree-list"
          :default-expand-all="false"
          highlight-current
          accordion
          :data="factoryTree"
          :expand-on-click-node="false"
          :props="defaultProps"
          @node-click="handleNodeClick"
          :render-content="testContent"
        >
        </el-tree>
      </el-scrollbar>
    </div>
    <!-- 左侧工厂树状结构结束 -->

    <!-- 右侧树状节点信息详情开始 -->
    <div class="right-store-list">
      <div style="margin: 0 24px; width: 95.4%">
        <div class="table_searchbar">
          <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-top: 20px">
            <el-tab-pane label="人员" name="0"></el-tab-pane>
            <el-tab-pane label="资源日历" name="1"></el-tab-pane>
            <el-tab-pane v-if="selectInfo.isResource" label="资源属性" name="2"></el-tab-pane>
          </el-tabs>
        </div>

        <div v-if="activeName == 0">
          <UserBase ref="user" :id.sync="id" />
        </div>

        <div v-if="activeName == 1">
          <calendarBase ref="child" :id.sync="selectInfo.id" />
        </div>

        <div v-if="activeName == 2 && selectInfo.isResource" style="margin: 0 10px">
          <div class="table_searchbar">
            <el-row :gutter="20">
              <el-col :span="10">
                <div class="">
                  <span class="title">资源编码：</span>
                  <span class="value">{{ selectInfo.code }}</span>
                </div>
              </el-col>
              <el-col :span="10">
                <div class="">
                  <span class="title">资源名称： </span>
                  <span class="value">{{ selectInfo.name }}</span>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="" style="text-align: right">
                  <el-button size="mini" type="primary" v-if="permission.btn_factoryModel_updateFactoryModel" @click="showEditDialog">编辑</el-button>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="10">
                <div class="">
                  <span class="title">资源类型：</span>
                  <span class="value">{{ selectInfo.typeName }}</span>
                </div>
              </el-col>
              <el-col :span="10">
                <div class="">
                  <span class="title">额定产能：</span>
                  <span class="value">{{ selectInfo.ratedCapacity }}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="10">
                <div class="">
                  <span class="title">标准工时：</span>
                  <span class="value">{{ selectInfo.standardCycle | filterTime }}</span>
                  <!-- <span class="value">{{selectInfo.standardCycle}}秒</span> -->
                </div>
              </el-col>
              <el-col :span="10" v-if="selectInfo.factoryType == 6 || selectInfo.factoryType == 8">
                <div class="">
                  <span class="title">库位数量：</span>
                  <span class="value">{{ tableData.length }}</span>
                  <!-- <span class="value">{{selectInfo.standardCycle}}秒</span> -->
                </div>
              </el-col>
            </el-row>
          </div>
          <div v-if="selectInfo.factoryType == 6 || selectInfo.factoryType == 8" style="margin: 20px 0px">
            <h4 style="display: inline-block; margin-right: 10px">仓位列表</h4>
            <el-button type="primary" size="mini" @click="batchAddStock">批量新增库位</el-button>
            <el-button type="primary" size="mini" @click="batchReView">预览布局图</el-button>
            <el-button type="primary" size="mini" @click="printAll(0)">批量打印条码</el-button>
            <el-button type="primary" size="mini" @click="printAll(1)">连续打印条码</el-button>
            <el-button type="primary" size="mini" @click="addSingleStock">新增</el-button>
            <span class="title" style="margin-left: 20px">库位名称：</span>
            <el-input style="max-width: 180px" size="small" v-model="factoryName" maxlength="20" placeholder="库位名称"></el-input>
            <el-button size="mini" icon="el-icon-search" type="primary" @click="searchFactoryModel">查询</el-button>
          </div>
          <!-- <el-row v-if='selectInfo.factoryType==6||selectInfo.factoryType==8'>
                        <el-col>
                            
                        </el-col>
                    </el-row> -->
          <el-table v-if="selectInfo.factoryType == 6 || selectInfo.factoryType == 8" :data="tableData" :maxHeight="544" style="width: 100%" class="deviceTable">
            <el-table-column :key="1" prop="positionName" label="库位名称" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column :key="2" prop="areaCode" label="库区编码" show-overflow-tooltip min-width="80"></el-table-column>
            <el-table-column :key="3" prop="cargoColumnNumber" label="货列号" show-overflow-tooltip min-width="80"></el-table-column>
            <el-table-column :key="5" prop="positionColumn" label="列" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column :key="4" prop="positionLayer" label="层" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column :key="6" prop="positionStatus" label="状态" :formatter="parsePositionStatus" show-overflow-tooltip min-width="80"></el-table-column>
            <el-table-column :key="7" label="操作">
              <template slot-scope="scope">
                <el-button @click="viewQRCode(scope.row)" type="text" size="small">二维码</el-button>
                <el-button @click="editStock(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="delStock(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-table v-if="selectInfo.factoryType == 3" :data="tableData" style="width: 100%" class="deviceTable">
            <el-table-column :key="10" prop="deviceCode" label="设备编码" show-overflow-tooltip min-width="80"></el-table-column>
            <el-table-column :key="11" prop="deviceName" label="设备名称" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column :key="12" prop="deviceType" label="设备类型" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column :key="13" prop="isDisabled" :formatter="parseStatus" label="使用状态" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column :key="14" prop="isBindDevice" v-if="selectInfo.factoryType == 2" :formatter="parseBindDevice" label="绑定设备" min-width="80" show-overflow-tooltip></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 右侧树状节点信息详情结束 -->

    <el-dialog title="新增组织" @close="cancelAddNodeDialog" :visible.sync="addDialogVisible" :width="span == 5 ? '26%' : '60%'" center :close-on-click-modal="false">
      <el-form :model="addNodeForm" :rules="rules" ref="add" style="width: 100%" class="add_form">
        <el-row :gutter="20">
          <el-col :span="18" :offset="3">
            <div class="">
              <span class="title" style="width: 70px"> 父组织：</span>
              <el-form-item class="value" style="display: inline-block">
                <el-select disabled v-model="addNodeForm.parentFactoryModelId" :placeholder="`请选择父组织`">
                  <el-option v-for="item in listResource" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="18" :offset="3">
            <div class="">
              <span class="title">组织编码：</span>
              <el-form-item prop="code" class="value" style="display: inline-block">
                <el-input v-model.trim="addNodeForm.code" :placeholder="`请输入组织编码`" maxlength="16"></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="18" :offset="3">
            <div class="">
              <span class="title">组织名称：</span>
              <el-form-item prop="name" class="value" style="display: inline-block">
                <el-input ref="focusinput" v-model.trim="addNodeForm.name" :placeholder="`请输入组织名称`" maxlength="16"></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="18" :offset="3">
            <div class="">
              <span class="title">组织属性：</span>
              <el-form-item prop="factoryType" class="value" style="display: inline-block">
                <el-select @change="factoryTypeChange($event, addNodeForm)" v-model="addNodeForm.factoryType" placeholder="组织属性">
                  <el-option v-for="item in typeOption1" :key="item.factoryType" :value="item.factoryType" :label="item.label"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="18" :offset="3">
            <div class="">
              <span class="title">生产资源：</span>
              <el-form-item class="value" style="display: inline-block">
                <el-checkbox :disabled="addNodeForm.factoryType == 10 || addNodeForm.factoryType == 11" v-model="addNodeForm.isResource"></el-checkbox>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="addNodeForm.isResource && addNodeForm.factoryType == 3">
          <el-col :span="18" :offset="3">
            <div class="">
              <span class="title">是否绑定设备：</span>
              <el-form-item class="value" style="display: inline-block">
                <el-checkbox v-model="addNodeForm.isBindDevice"></el-checkbox>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitAddNode">确 定</el-button>
        <el-button @click="cancelAddNodeDialog">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="编辑组织" @close="cancelEditNodeDialog" :visible.sync="eidtNodeDialogVisible" :width="span == 5 ? '26%' : '60%'" center :close-on-click-modal="false">
      <el-form :model="addNodeForm" :rules="rules" ref="editNode" style="width: 100%" class="add_form">
        <el-row :gutter="20">
          <el-col :span="18" :offset="3">
            <div class="">
              <span class="title" style="width: 70px"> 父组织：</span>
              <el-form-item class="value" style="display: inline-block">
                <el-select v-model="addNodeForm.parentFactoryModelId" :placeholder="`请选择父组织`" filterable>
                  <el-option v-for="item in listResourceCopy" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="18" :offset="3">
            <div class="">
              <span class="title">组织编码：</span>
              <el-form-item prop="code" class="value" style="display: inline-block">
                <el-input v-model.trim="addNodeForm.code" :placeholder="`请输入组织编码`" maxlength="16"></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="18" :offset="3">
            <div class="">
              <span class="title">组织名称：</span>
              <el-form-item prop="name" class="value" style="display: inline-block">
                <el-input ref="focusinput" v-model.trim="addNodeForm.name" :placeholder="`请输入组织名称`" maxlength="16"></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="18" :offset="3">
            <div class="">
              <span class="title">组织属性：</span>
              <el-form-item prop="factoryType" class="value" style="display: inline-block">
                <el-select @change="factoryTypeChange($event, addNodeForm)" disabled v-model="addNodeForm.factoryType" placeholder="组织属性">
                  <el-option :disabled="item.disabled" v-for="item in typeOption" :key="item.factoryType" :value="item.factoryType" :label="item.label"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="18" :offset="3">
            <div class="">
              <span class="title">生产资源：</span>
              <el-form-item class="value" style="display: inline-block">
                <el-checkbox :disabled="addNodeForm.factoryType == 10 || addNodeForm.factoryType == 11" v-model="addNodeForm.isResource"></el-checkbox>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="addNodeForm.isResource && addNodeForm.factoryType == 3">
          <el-col :span="18" :offset="3">
            <div class="">
              <span class="title">是否绑定设备：</span>
              <el-form-item class="value" style="display: inline-block">
                <el-checkbox v-model="addNodeForm.isBindDevice"></el-checkbox>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitEditNode">确 定</el-button>
        <el-button @click="cancelEditNodeDialog">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 编辑工厂开始 -->
    <el-dialog :title="`编辑资源`" @close="cancelEditDialog" :visible.sync="eidtDialogVisible" :width="span == 5 ? '50%' : '60%'" center :close-on-click-modal="false">
      <el-form :model="addForm" :rules="rules" ref="edit" style="width: 100%" class="add_form">
        <el-row :gutter="20" style="margin-bottom: 0px">
          <el-col :span="12">
            <div class="">
              <span class="title">资源名称：</span>
              <el-form-item prop="name" class="value" style="display: inline-block">
                <el-input ref="focusinput" v-model.trim="addForm.name" :placeholder="`请输入资源名称`" maxlength="16"></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="">
              <span class="title">资源编码：</span>
              <el-form-item prop="code" class="value" style="display: inline-block">
                <el-input disabled v-model.trim="addForm.code" :placeholder="`请输入资源编码`" maxlength="16"></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20" style="margin-bottom: 0px">
          <el-col :span="12">
            <div class="">
              <span class="title">资源属性：</span>
              <el-form-item prop="description" style="display: inline-block">
                <el-select disabled v-model="addForm.factoryType" placeholder="组织属性">
                  <el-option v-for="item in typeOption" :key="item.factoryType" :value="item.factoryType" :label="item.label"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="">
              <span class="title">额定产能：</span>
              <el-form-item prop="ratedCapacity" style="display: inline-block">
                <el-input v-model.trim="addForm.ratedCapacity" :placeholder="`请输入额定产能`" maxlength="16"></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-bottom: 0px">
          <el-col :span="12">
            <div class="">
              <span class="title">标准工时：</span>
              <el-form-item prop="standardCycle" style="display: inline-block">
                <el-input v-model.trim="addForm.standardCycle" :placeholder="`请输入标准工时`" maxlength="16" style="display: inline-block; width: 100px"></el-input>
                <el-select v-model="addForm.timeType" placeholder="单位" style="display: inline-block; width: 80px">
                  <el-option :key="0" :value="0" label="/小时"></el-option>
                  <el-option :key="1" :value="1" label="/分钟"></el-option>
                  <el-option :key="2" :value="2" label="/秒"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-row v-if="selectInfo.factoryType == 3 || selectInfo.factoryType == 6 || selectInfo.factoryType == 8" style="margin-bottom: 6px">
          <el-col :span="24">
            <el-button type="primary" @click="addItem()" v-if="selectInfo.factoryType != 6 && selectInfo.factoryType != 8">新增</el-button>
            <el-button type="primary" v-if="selectInfo.factoryType == 3" @click="bindDeviceType">关联设备类型</el-button>
          </el-col>
        </el-row>
        <!-- 新增库位 -->
        <!-- <el-table v-if='selectInfo.factoryType==6||selectInfo.factoryType==8' :maxHeight="388" :data="sonList" stripe style="width: 100%;margin-bottom:10px;" class="marterial-table">
                    <el-table-column label="库位名称" min-width="120">
                        <template slot-scope="scope">
                            <el-form-item >
                                {{parsePositionName(scope.row)}}
                            </el-form-item>
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="库区编码" min-width="70">
                        <template slot-scope="scope">
                            <el-form-item :prop="`sonList[${scope.$index}].areaCode`"  :rules="rules.areaCode">
                                <el-input v-model.trim="scope.row.areaCode" maxlength="16"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="货列号" min-width="70">
                        <template slot-scope="scope">
                            <el-form-item :prop="`sonList[${scope.$index}].cargoColumnNumber`"  :rules="rules.cargoColumnNumber">
                                <el-input v-model.trim="scope.row.cargoColumnNumber" maxlength="16"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="列" min-width="70">
                        <template slot-scope="scope">
                            <el-form-item :prop="`sonList[${scope.$index}].positionColumn`"  :rules="rules.positionColumn">
                                <el-input v-model="scope.row.positionColumn" maxlength="8"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="层" min-width="70">
                        <template slot-scope="scope">
                            <el-form-item :prop="`sonList[${scope.$index}].positionLayer`"  :rules="rules.positionLayer">
                                <el-input v-model="scope.row.positionLayer" maxlength="8"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态" min-width="90">
                        <template slot-scope="scope">
                            <el-form-item   >
                                <el-select  v-model="scope.row.positionStatus" placeholder="使用状态" >
                                    <el-option  key="0" :value="0" label="启用"></el-option>
                                    <el-option  key="1" :value="1" label="停用"></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="70">
                        <template slot-scope="scope">
                            <el-form-item>
                                <div class="delete" type="primary" @click="removeItem(scope.$index)"></div>
                            </el-form-item>
                        </template>
                    </el-table-column>
                </el-table> -->

        <!-- 新增设备 -->
        <el-table v-if="selectInfo.factoryType == 3" :data="sonList" stripe style="width: 100%; margin-bottom: 10px" class="marterial-table">
          <el-table-column :label="`设备名称`" min-width="120">
            <template slot-scope="scope">
              <el-form-item>
                <el-select
                  popper-class="select_device_width"
                  :rules="rules.itemName"
                  clearable
                  remote
                  filterable
                  :remote-method="
                    query => {
                      remoteMethod(query, '', scope);
                    }
                  "
                  :loading="loading"
                  @change="deviceSelect($event, scope.$index)"
                  v-model="scope.row.deviceId"
                  placeholder="设备名称"
                >
                  <el-option :title="item.deviceName" v-for="item in deviceList[scope.$index]" :key="item.id" :label="item.deviceName" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column :label="`设备编码`" min-width="120">
            <template slot-scope="scope">
              <el-form-item :prop="`sonList[${scope.$index}].deviceId`" :rules="rules.deviceId">
                <el-select
                  popper-class="select_device_width"
                  :rules="rules.itemName"
                  clearable
                  remote
                  filterable
                  :remote-method="
                    query => {
                      remoteMethod('', query, scope);
                    }
                  "
                  :loading="loading"
                  @change="deviceSelect($event, scope.$index)"
                  v-model="scope.row.deviceId"
                  placeholder="设备编码"
                >
                  <el-option :title="item.deviceCode" v-for="item in deviceList[scope.$index]" :key="item.id" :label="item.deviceCode" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column :label="`设备类型`" min-width="120">
            <template slot-scope="scope">
              <el-form-item>
                <el-select v-model="scope.row.deviceTypeId" placeholder="设备类型" @change="deviceTypeChange($event, scope.$index)">
                  <el-option v-for="item in deviceTypeOptions" :key="item.id" :label="item.deviceType" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="使用状态" min-width="90">
            <template slot-scope="scope">
              <el-form-item :prop="`sonList[${scope.$index}]`">
                <el-select v-model="scope.row.deviceStatus" placeholder="使用状态" @change="deviceStatusChange($event, scope.$index)">
                  <el-option v-for="item in deviceStatusOptions" :key="item.id" :value="item.id" :label="item.label"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="70">
            <template slot-scope="scope">
              <el-form-item>
                <div class="delete" type="primary" @click="removeItem(scope.$index)"></div>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer" class="dialog-footer" style="margin-top: -30px">
        <el-button type="primary" @click="submitEdit">确 定</el-button>
        <el-button @click="cancelEditDialog">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 编辑工厂结束 -->

    <!-- 批量导入提示框开始 -->
    <el-dialog title="导入详情" style="z-index: 99999999999" :close-on-click-modal="false" :visible.sync="exportDialogVisible" :width="W ? '25%' : '30%'" center>
      <div class="exprot_info" style="text-align: center">
        <el-row :gutter="20">
          <span>总共导入设备条数：</span>
          <span>{{ exportInfo.total }}条</span>
        </el-row>
        <el-row :gutter="20">
          <span>导入设备成功条数：</span>
          <span>{{ exportInfo.success }}条</span>
        </el-row>
        <el-row :gutter="20">
          <span>导入设备失败条数：</span>
          <span>{{ exportInfo.fail }}条</span>
        </el-row>
      </div>
      <span slot="footer" class="el-dialog__footer" style="text-align: center" center>
        <a class="import_upload" v-if="exportInfo.url" :href="exportInfo.url">
          <el-button type="primary">下载失败数据</el-button>
        </a>
        <el-button
          type="primary"
          style="margin-left: 10px"
          @click="
            () => {
              this.exportDialogVisible = false;
            }
          "
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 批量导入提示框结束 -->

    <el-dialog title="二维码" :visible.sync="qrCodeDialogVisible" width="30%" center>
      <div id="qrcode" class="qrcode_div" ref="qrcodediv">
        <QrcodeVue :value="printInfo.codeValue" size="200" level="H"></QrcodeVue>
      </div>
      <div class="qrcode_div" style="margin-top: 20px">
        <div style="margin-top: 5px">
          <span>货列号:{{ printInfo.cargoColumnNumber }}</span>
        </div>
        <div style="margin-top: 5px">
          <span>库位名称:{{ printInfo.positionName }}</span>
        </div>
        <div style="margin-top: 5px; margin-bottom: 5px">
          <span>库区编码:{{ printInfo.areaCode }}</span>
        </div>
        <el-button type="primary" @click="printQRCode()" size="medium">打印</el-button>
      </div>
    </el-dialog>

    <el-dialog title="关联设备类型" :visible.sync="deviceTypeDialogVisible" :close-on-click-modal="false" width="30%" center>
      <div class="qrcode_div" style="margin-top: 20px">
        <div style="margin-top: 5px">
          <span>设备类型</span>
          <el-select clearable style="max-width: 180px" multiple filterable v-model="deviceTypeList" size="small" maxlength="16" placeholder="设备类型" @keyup.enter.native="search">
            <el-option v-for="item in deviceTypeOptions" :key="item.id" :label="item.deviceType" :value="item.id"></el-option>
          </el-select>
        </div>
        <div style="margin-top: 20px">
          <el-button type="primary" @click="submitBindDeviceType">确定</el-button>
          <el-button @click="cancelBindDeviceType">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <AddStockDialog :id.sync="selectInfo.id" :showBatchStock="showBatchStock" />
    <ReViewDialog :id.sync="selectInfo.id" :showReView="showReView" />
    <PrintStockDialog :showPrintStock="showPrintStock" :printData="printData" :size="size" />
    <SingleAddStock :editInfo="editInfo" :factoryModelId.sync="selectInfo.id" :showBatchStock="showSingleStock" :isAdd="isAdd"></SingleAddStock>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import CalendarBase from "../Organization/CalendarBase.vue";
import UserBase from "../Organization/UserBase.vue";
import AddStockDialog from "./AddStockDialog";
import ReViewDialog from "./ReViewDialog";
import PrintStockDialog from "./PrintStockDialog";
import SingleAddStock from "./singleAddStock.vue";
export default {
  name: "FactoryModel",
  components: {
    QrcodeVue,
    CalendarBase,
    UserBase,
    AddStockDialog,
    PrintStockDialog,
    ReViewDialog,
    SingleAddStock
  },
  data() {
    let that = this;
    return {
      showPrintStock: false,
      showBatchStock: false,
      size: 0,
      showReView: false,
      printData: [],
      activeName: "0",
      deviceTypeList: [],
      deviceTypeDialogVisible: false,
      exportDialogVisible: false,
      exportInfo: {
        success: 0,
        fail: 0,
        url: "",
        total: 0
      },
      isAdd: false,
      showSingleStock: false,
      editInfo: {},
      id: null,
      eidtNodeDialogVisible: false,
      qrCodeDialogVisible: false,
      printInfo: {},
      loading: false,
      title: "工厂",
      subTitle: "机组",
      selecTree: 1,
      factoryTree: [],
      organizationData: [],
      selectId: 0,
      activeType: 1, //1显示机组 2显示仓库
      defaultProps: {
        children: "sonList",
        label: "name"
      },
      deviceStatusOptions: [
        { id: 0, label: "正常" },
        { id: 1, label: "维修中" },
        { id: 2, label: "保养中" },
        { id: 3, label: "未启用" },
        { id: 4, label: "报废" },
        { id: 5, label: "停用" }
      ],
      sonList: [],
      selectInfo: {
        id: null,
        name: "",
        code: "",
        layer: 0
      },
      addForm: {
        name: "",
        code: "",
        description: "",
        sonList: [],
        stockList: []
      },
      addNodeForm: {
        name: "",
        code: "",
        isResource: false,
        factoryType: null,
        id: null,
        parentFactoryModelId: null,
        isBindDevice: false
      },
      listResource: [],
      addDialogVisible: false,
      eidtDialogVisible: false,
      W: false,
      // factoryType 0-工厂 1-机组   2-产线 3-工作中心 4-仓库 5-模具仓库 6-模具子仓  7-物料仓库 8-物料子仓
      rules: {
        name: [{ required: true, message: `请输入名称`, trigger: "blur" }],
        code: [{ required: true, message: `请输入编码`, trigger: "blur" }],
        factoryType: [{ required: true, message: `请选择属性`, trigger: "blur" }],
        itemName: [
          {
            validator(rule, item, callback) {
              let value = item.name;
              if (value) {
                callback();
              } else {
                callback(new Error(`请输入资源名称`));
              }
            },
            trigger: "blur"
          }
        ],
        itemCode: [
          {
            validator(rule, item, callback) {
              let value = item.code;
              if (value) {
                callback();
              } else {
                callback(new Error(`请输入资源编码`));
              }
            },
            trigger: "blur"
          }
        ],
        stockName: [
          {
            validator(rule, item, callback) {
              let value = item.name;
              if (value) {
                callback();
              } else {
                callback(new Error(`请输入仓库名称`));
              }
            },
            trigger: "blur"
          }
        ],
        stockCode: [
          {
            validator(rule, item, callback) {
              let value = item.code;
              if (value) {
                callback();
              } else {
                callback(new Error(`请输入仓库编码`));
              }
            },
            trigger: "blur"
          }
        ],
        deviceId: [{ required: true, message: "请选择设备", trigger: "blur" }],
        positionName: [{ required: true, message: "请输入库位名称", trigger: "blur" }],
        cargoColumnNumber: [{ required: true, message: "请输入货列号", trigger: "blur" }],
        positionLayer: [
          {
            validator(rule, value, callback) {
              if (value) {
                value = Number(value);
                if (isNaN(value)) {
                  callback(new Error("请输入数字"));
                } else {
                  if (Number.isInteger(value) && value > 0) {
                    callback();
                  } else {
                    callback(new Error("请输入正整数"));
                  }
                }
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        positionColumn: [
          {
            validator(rule, value, callback) {
              if (value) {
                value = Number(value);
                if (isNaN(value)) {
                  callback(new Error("请输入数字"));
                } else {
                  if (Number.isInteger(value) && value > 0) {
                    callback();
                  } else {
                    callback(new Error("请输入正整数"));
                  }
                }
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        standardCycle: [
          {
            validator(rule, value, callback) {
              if (value) {
                value = Number(value);
                if (isNaN(value)) {
                  callback(new Error("标准工时必须为数字"));
                } else {
                  if (Number.isInteger(value) && value >= 0) {
                    callback();
                  } else {
                    callback(new Error("标准工时必须为正整数"));
                  }
                }
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        ratedCapacity: [
          {
            validator(rule, value, callback) {
              if (value) {
                value = Number(value);
                if (isNaN(value)) {
                  callback(new Error("额定产能必须为数字"));
                } else {
                  if (value >= 0) {
                    callback();
                  } else {
                    callback(new Error("额定产能不能小于零"));
                  }
                }
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      },
      factoryName: "",
      typeOption: [
        { factoryType: 0, label: "部门", disabled: false },
        { factoryType: 1, label: "机组", disabled: false }
        // { factoryType: 2, label: "产线", disabled: false },
        // { factoryType: 3, label: "工作中心", disabled: false },
        // { factoryType: 4, label: "仓库", disabled: true },
        // { factoryType: 5, label: "模具仓库", disabled: true },
        // { factoryType: 6, label: "模具子仓", disabled: false },
        // { factoryType: 7, label: "物料仓库", disabled: true },
        // { factoryType: 8, label: "物料子仓", disabled: false },
        // { factoryType: 10, label: "部门", disabled: false },
        // { factoryType: 11, label: "工段", disabled: false }
      ],
      typeOption1: [
        { factoryType: 0, label: "部门" },
        { factoryType: 1, label: "机组" }
        // { factoryType: 2, label: "产线" },
        // { factoryType: 3, label: "工作中心" },
        // // {factoryType:4,label:'仓库'},
        // // {factoryType:5,label:'模具仓库'},
        // { factoryType: 6, label: "模具仓库" },
        // // {factoryType:7,label:'物料仓库'},
        // { factoryType: 8, label: "物料仓库" },
        // { factoryType: 10, label: "部门" },
        // { factoryType: 11, label: "工段" }
      ],
      tableData: [],
      stockList: [],
      deviceList: [],
      deviceListBase: [],
      deviceTypeOptions: [],
      materialStockList: [],
      listResourceCopy: [],
      permission: JSON.parse(localStorage.getItem("permission"))
    };
  },
  mounted: async function() {
    await this.loadOrganizationData();
    await this.loadListResource();
    this.loadDeviceTypeList();
    this.deviceListBase = await this.loadDeviceList();
    let w = document.documentElement.clientWidth || document.body.clientWidth;
    w >= 1900 ? (this.W = true) : (this.W = false);
    window.onresize = () => {
      let w = document.documentElement.clientWidth || document.body.clientWidth;
      w >= 1900 ? (this.W = true) : (this.W = false);
    };
  },
  computed: {
    span() {
      return this.W ? 5 : 7;
    }
  },
  methods: {
    batchAddStock() {
      this.showBatchStock = true;
    },
    batchReView() {
      this.showReView = true;
    },
    printAll(size) {
      this.printData = this.tableData;
      this.printData.forEach(item => {
        item.pName = this.selectInfo.name;
      });
      this.size = size;
      this.showPrintStock = true;
    },

    bindDeviceType() {
      this.deviceTypeDialogVisible = true;
    },

    factoryTypeChange(ev) {
      if (ev == 10 || ev == 11) {
        this.$set(this.addNodeForm, "isResource", false);
      }
    },
    cancelAddNodeDialog() {
      this.addDialogVisible = false;
      this.addNodeForm = {
        name: "",
        code: "",
        isResource: false,
        factoryType: null,
        id: null,
        parentFactoryModelId: null,
        isBindDevice: false
      };
    },

    submitAddNode() {
      this.$refs["add"].validate(valid => {
        if (valid) {
          this.$RequestUtil.post({
            url: "/api/factoryModel/addFactoryModelNode",
            type: "sync",
            params: this.addNodeForm,
            success: async res => {
              if (res.code == 0) {
                this.$message.success("新增成功");
                let id = res.data;
                this.selecTree = id;
                this.$store.commit("add_reloadPages", ["/MasterData/DeviceMgt", "/TechnologyBOM/TechnologyTemplate", "/TechnologyBOM/ProcedureMapWorkshop"]);
                this.cancelAddNodeDialog();
                await this.loadOrganizationData(id);
                await this.loadListResource();
              } else {
                this.$message.error(res.msg || res.message);
              }
            }
          });
        }
      });
    },

    addFactory(data) {
      this.$set(this.addNodeForm, "parentFactoryModelId", data.id);
      this.addDialogVisible = true;
    },

    editFactory(data) {
      log(data, "当前节点");
      this.addNodeForm = commonUtils.cloneObj(data);
      this.$set(this.addNodeForm, "parentFactoryModelId", data.parentId);
      this.listResourceCopy = this.listResource.filter(item => item.name != this.addNodeForm.name);
      this.eidtNodeDialogVisible = true;
    },

    cancelEditNodeDialog() {
      this.eidtNodeDialogVisible = false;
      this.addNodeForm = {
        name: "",
        code: "",
        isResource: false,
        factoryType: null,
        id: null,
        parentFactoryModelId: null,
        isBindDevice: false
      };
    },

    submitEditNode() {
      this.$refs["editNode"].validate(valid => {
        if (valid) {
          this.$RequestUtil.post({
            url: "/api/factoryModel/updateFactoryModelNode",
            type: "sync",
            params: this.addNodeForm,
            success: async res => {
              if (res.code == 0) {
                this.$message.success("编辑成功");
                let id = this.addNodeForm.id;
                this.$store.commit("add_reloadPages", ["/MasterData/DeviceMgt", "/TechnologyBOM/TechnologyTemplate", "/TechnologyBOM/ProcedureMapWorkshop"]);
                this.cancelEditNodeDialog();
                await this.loadOrganizationData(id);
                await this.loadListResource();
              } else {
                this.$message.error(res.msg || res.message);
              }
            }
          });
        }
      });
    },

    submitBindDeviceType() {
      if (this.deviceTypeList.length == 0) {
        this.$message.warning("请选择选用关联的设备类型");
        return;
      }
      log(this.selectInfo, 666);
      let params = {
        factoryModelId: this.selectInfo.id,
        deviceTypeList: this.deviceTypeList
      };
      this.$RequestUtil.post({
        url: "/api/factoryModel/linkDeviceType",
        type: "sync",
        params,
        success: async res => {
          if (res.code == 0) {
            this.$message.success("关联成功");
            this.sonList = (await this.loadDeviceListByProductionLineId(this.selectInfo.id)).deviceList;
            this.addForm.sonList = this.sonList;
            this.sonList.forEach(async (item, index) => {
              item.deviceId = Number(item.deviceId);
              let data = [
                {
                  id: item.id,
                  deviceName: item.deviceName,
                  deviceCode: item.deviceCode,
                  isDisabled: item.isDisabled,
                  deviceTypeId: item.deviceTypeId
                }
              ];
              this.$set(this.deviceList, index, data);
            });
            this.tableData = commonUtils.cloneObj(this.sonList);
            this.cancelBindDeviceType();
          } else {
            this.$message.error(res.msg || res.message);
          }
        }
      });
    },

    cancelBindDeviceType() {
      this.deviceTypeDialogVisible = false;
      this.deviceTypeList = [];
    },

    async handleClick() {
      this.id = this.selectInfo.id;
      if (this.activeName == 0) {
        setTimeout(async () => {
          await this.$refs.user.loadUserList(this.id);
        }, 0);
      } else if (this.activeName == 2) {
        let info = this.selectInfo;
        if (info.factoryType == 3) {
          let { deviceList } = await this.loadDeviceListByProductionLineId(info.id);
          this.tableData = deviceList;
        } else if (info.factoryType == 6 || info.factoryType == 8) {
          this.factoryName = "";
          this.tableData = (await this.loadDeviceListByProductionLineId(info.id)).factoryModelPositionList;
        } else {
          this.tableData = info.sonList;
        }
      } else {
        if (this.$refs.child && this.$refs.child.init) {
          this.$refs.child.init(this.id);
        }
      }
    },

    async searchFactoryModel() {
      this.tableData = (await this.loadDeviceListByProductionLineId(this.selectInfo.id, this.factoryName)).factoryModelPositionList;
    },

    reload() {
      this.loadDeviceTypeList();
      this.$store.commit("delete_reloadPages", "/MasterData/FactoryModel");
    },

    printQRCode: function() {
      var ss = this.$refs.qrcodediv;
      var imageToPrint = document.getElementById("qrcode").childNodes[0].childNodes[0]; //将要被打印的图片
      var printWindow = window.open(""); //新打开一个空窗口
      printWindow.document.write("<img src='" + imageToPrint.toDataURL() + "'/>"); //将图片添加进新的窗口
      printWindow.document.write("<div style='margin-top:5px'><span>货列号:" + this.printInfo.cargoColumnNumber + "</span></div>");
      printWindow.document.write("<div style='margin-top:5px'><span>库位名称:" + this.printInfo.positionName + "</span></div>");
      printWindow.document.write("<div style='margin-top:5px;margin-bottom:5px;'><span>库区编码:" + this.printInfo.areaCode + "</span></div>");
      printWindow.document.close(); //在IE浏览器中使用必须添加这一句
      printWindow.focus(); //在IE浏览器中使用必须添加这一句
      setTimeout(function() {
        printWindow.document.body.style.textAlign = "center";
        printWindow.print(); //打印
        printWindow.close(); //关闭窗口
      }, 100);
    },

    viewQRCode: function(rowData) {
      this.qrCodeDialogVisible = true;
      this.printInfo = commonUtils.cloneObj(rowData);
    },
    delStock(rowData) {
      let message = "此操作将删除库位，是否继续";

      this.$confirm(message, "提示", {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$RequestUtil.post({
          url: "/api/factoryModelPosition/deleteFactoryModelPosition",
          type: "sync",
          params: {
            id: rowData.id
          },
          success: async res => {
            if (res.code != -1) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              await this.loadOrganizationData(this.selectId);
            } else {
              this.$message({
                type: "error",
                message: res.msg || res.message
              });
            }
          }
        });
      });
    },

    editStock(row) {
      this.showSingleStock = true;
      this.isAdd = false;
      this.editInfo = commonUtils.cloneObj(row);
    },

    addSingleStock() {
      this.isAdd = true;
      this.showSingleStock = true;
    },

    parsePositionStatus(rowData) {
      let str = "";
      if (rowData.positionStatus == 0) {
        str = "启用";
      } else if (rowData.positionStatus == 1) {
        str = "停用";
      }
      return str;
    },

    async deviceTypeChange(ev, index) {
      this.$set(this.sonList[index], "deviceId", null);
      let removeList = (this.sonList || []).map(item => item.deviceId).filter(item => item);
      if (ev != null && ev != undefined) {
        this.$set(this.deviceList, index, await this.loadDeviceList("", "", ev, null, removeList));
      } else {
        this.deviceList[index] = commonUtils.cloneObj(this.deviceListBase);
      }
    },

    deviceSelect(ev, index) {
      if (ev) {
        let selectItem = this.deviceList[index].find(item => item.id == ev);
        if (selectItem) {
          this.$set(this.sonList[index], "deviceStatus", selectItem.deviceStatus);
          this.$set(this.sonList[index], "deviceTypeId", selectItem.deviceTypeId);
        }
      }
    },

    async remoteMethod(deviceName, deviceCode, scope) {
      let index = scope.$index;
      let { deviceTypeId, deviceStatus, deviceId } = scope;
      let removeList = (this.sonList || []).map(item => item.deviceId).filter(item => item && item != deviceId);
      this.loading = true;
      let data = await this.loadDeviceList(deviceName, deviceCode, deviceTypeId, deviceStatus, removeList);
      this.$set(this.deviceList, index, data);
      this.loading = false;
    },

    async deviceStatusChange(ev, index) {
      this.$set(this.sonList[index], "deviceId", null);
      let removeList = (this.sonList || []).map(item => item.deviceId).filter(item => item);
      if (ev != null && ev != undefined) {
        let data = await this.loadDeviceList("", "", null, ev, removeList);
        this.$set(this.deviceList, index, data);
      } else {
        this.deviceList[index] = commonUtils.cloneObj(this.deviceListBase);
      }
    },

    async loadDeviceList(deviceName, deviceCode, deviceTypeId, deviceStatus, removeDeviceList = [], addDeviceId) {
      let { data, code, msg, message } = await this.$RequestUtil.postAsync({
        url: "/api/select/listDeviceSelect",
        type: "sync",
        params: {
          deviceName,
          deviceCode,
          deviceTypeId,
          deviceStatus,
          removeDeviceList,
          addDeviceId
        }
      });
      if (code == 0) {
        return data;
      } else {
        this.$message.error(msg || message);
      }
    },

    async loadDeviceTypeList() {
      let { data, code, msg, message } = await this.$RequestUtil.getAsync({
        url: "/api/device/listDeviceType",
        type: "sync",
        params: {}
      });
      if (code == 0) {
        this.deviceTypeOptions = data;
      } else {
        this.$message.error(msg || message);
      }
    },

    parseDeviceType: function(val) {
      let type = "";
      this.deviceTypeOptions.forEach(item => {
        if (item.id == val.deviceTypeId) {
          type = item.deviceType;
        }
      });
      return type;
    },

    parseStatus(item) {
      return (this.deviceStatusOptions.find(d => d.id == item.deviceStatus) || {}).label;
    },
    parseBindDevice(row) {
      if (row.isBindDevice) {
        return "是";
      } else {
        return "否";
      }
    },

    async loadOrganizationData(id) {
      let res = await this.$RequestUtil.getAsync({
        url: "/api/factoryModel/listFactoryModel",
        type: "sync",
        params: {}
      });
      if (res.code == 0) {
        this.factoryTree = [res.data];
        if (id) {
          setTimeout(async () => {
            this.selectId = id;
            this.$refs.tree.setCurrentKey(id);
            this.selecTree = id;
            let info = this.$refs.tree.getCurrentNode();
            this.selectInfo = commonUtils.cloneObj(info);
            if (!this.selectInfo.isResource && this.activeName == 2) {
              this.activeName = "0";
            }
            this.handleClick();
          }, 0);
        } else {
          if (res.data && res.data.sonList && res.data.sonList.length > 0) {
            this.selecTree = res.data.sonList[0].id;
          }
          this.selectInfo = commonUtils.cloneObj(res.data);
          if (!this.selectInfo.isResource && this.activeName == 2) {
            this.activeName = "0";
          }
          this.tableData = res.data.sonList;
          this.selectId = res.data.id;
          this.handleClick();
        }
      } else {
        this.$message.error(res.msg || res.message);
      }
    },

    parsePositionName(row) {
      let cargoColumnNumber = row.cargoColumnNumber ? `-${row.cargoColumnNumber}` : "";
      let areaCode = row.areaCode ? `${row.areaCode}` : "";
      let layer = row.positionLayer ? `-${row.positionLayer}` : "";
      let column = row.positionColumn ? `-${row.positionColumn}` : "";
      row.positionName = `${areaCode}${cargoColumnNumber}${column}${layer}`;
      return row.positionName;
    },

    parseGmtCreate: function(rowData) {
      if (rowData.gmtCreate != null) {
        let dateString = commonUtils.timestampToDate(rowData.gmtCreate);
        return dateString;
      }
    },

    parseGmtModified: function(rowData) {
      if (rowData.gmtModified != null) {
        let dateString = commonUtils.timestampToDate(rowData.gmtModified);
        return dateString;
      }
    },

    async addItem() {
      let layer = this.selectInfo.layer + 1;
      let factoryType = this.selectInfo.factoryType + 1;
      if (factoryType == 6 || factoryType == 8) {
        this.sonList.push({ layer, factoryType, positionStatus: 0 });
      } else {
        this.sonList.push({ layer, factoryType });
      }
    },

    removeItem(index) {
      this.sonList.splice(index, 1);
      this.deviceList.splice(index, 1);
    },

    testContent(h, { node, data, store }) {
      if (data.layer == undefined) {
        data.layer = 0;
      }
      let widthData = ["150px", "140px", "130px", "120px", "110px", "100px", "90px", "80px", "70px", "60px", "50px"];
      let widthData2 = ["69px", "59px", "49px", "39px", "29px", "19px"];
      let widthList = ["137px", "73px", "91px"];
      let widthList2 = ["101px", "35px", "95px"];
      let fontSize = "14px";
      if (!this.W) {
        widthData = ["110px", "100px", "90px", "80px", "70px", "60px", "50px", "40px", "30px", "20px"];
        let widthData2 = ["69px", "59px", "49px", "39px", "29px", "19px"];
        widthList = ["109px", "58px", "72px"];
        widthList2 = ["101px", "35px", "95px"];
        fontSize = "12px";
      }
      let styleJson = {
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        fontSize,
        paddingRight: "8px",
        height: "34px"
      };
      let json1 = {
        width: "92px",
        height: "34px",
        textAlign: "center",
        borderLeft: "1px solid #ccc",
        lineHeight: "34px",
        overflow: "hidden"
      };
      let typeOption = [
        { factoryType: 0, label: "部门" },
        { factoryType: 1, label: "机组" }
        // { factoryType: 2, label: "产线" },
        // { factoryType: 3, label: "工作中心" },
        // { factoryType: 4, label: "仓库" },
        // { factoryType: 5, label: "模具仓库" },
        // { factoryType: 6, label: "模具子仓" },
        // { factoryType: 7, label: "物料仓库" },
        // { factoryType: 8, label: "物料子仓" },
        // { factoryType: 10, label: "部门" },
        // { factoryType: 11, label: "工段" }
      ];
      data.typeName = (typeOption.find(item => item.factoryType == data.factoryType) || {}).label;
      let html;
      if (!this.permission.btn_factoryModel_updateFactoryModel) {
        html = (
          <span style={styleJson}>
            <span
              title={data.code}
              style={{
                width: `${widthData2[data.layer + 1]}`,
                display: "inline-block",
                height: "34px",
                overflow: "hidden",
                lineHeight: "34px"
              }}
            >
              <span class="show-ellipsis">{data.code}</span>
            </span>
            <span title={data.name} style={{ ...json1, width: widthList2[0] }}>
              <span class="show-ellipsis">{data.name}</span>
            </span>
            <span style={{ ...json1, width: widthList2[1] }}>
              <span class="show-ellipsis" style={{ display: "inline-block" }}>
                <input type="checkbox" checked={data.isResource} disabled="disabled" />
              </span>
            </span>
            <span style={{ ...json1, width: widthList2[2] }}>
              <span class="show-ellipsis" style={{ display: "inline-block" }}>
                {data.typeName}
              </span>
            </span>
          </span>
        );
      } else {
        html = (
          <span style={styleJson}>
            <span
              title={data.code}
              style={{
                width: `${widthData[data.layer + 1]}`,
                display: "inline-block",
                height: "34px",
                overflow: "hidden",
                lineHeight: "34px"
              }}
            >
              <span class="show-ellipsis">{data.code}</span>
            </span>
            <span title={data.name} style={{ ...json1, width: widthList[0] }}>
              <span class="show-ellipsis">{data.name}</span>
            </span>
            <span style={{ ...json1, width: widthList[1] }}>
              <span class="show-ellipsis" style={{ display: "inline-block" }}>
                <input type="checkbox" checked={data.isResource} disabled="disabled" />
              </span>
            </span>
            <span style={{ ...json1, width: widthList[2] }}>
              <span class="show-ellipsis" style={{ display: "inline-block" }}>
                {data.typeName}
              </span>
            </span>
            <span style={json1}>
              <span class="show-ellipsis" style={{ fontSize: "12px" }}>
                <img src="../../static/img/add.png" style="margin:10px 0px;width:14px" on-click={() => this.addFactory(data)} />
                <img
                  src="../../static/img/edit.png"
                  style={{
                    display: data.layer == -1 ? "none" : "inline-block",
                    margin: "10px 8px",
                    width: "14px"
                  }}
                  on-click={() => this.editFactory(data)}
                />
                <img
                  src="../../static/img/close.png"
                  style={{
                    display: data.layer == -1 ? "none" : "inline-block",
                    margin: "10px 0px",
                    width: "14px"
                  }}
                  on-click={() => this.deleteItem(data)}
                />
              </span>
            </span>
          </span>
        );
      }

      // if (this.permission.btn_factoryModel_updateFactoryModel) {
      //   html += (

      //   );
      // }

      return html;
    },

    showEditDialog() {
      this.addForm = commonUtils.cloneObj(this.selectInfo);
      this.sonList = commonUtils.cloneObj(this.tableData);
      this.addForm.sonList = this.sonList;
      this.$set(this.addForm, "timeType", 2);
      if (this.selectInfo.factoryType == 3 && this.sonList.length > 0) {
        this.sonList.forEach(async (item, index) => {
          item.deviceId = Number(item.deviceId);
          let data = [
            {
              id: item.id,
              deviceName: item.deviceName,
              deviceCode: item.deviceCode,
              isDisabled: item.isDisabled,
              deviceTypeId: item.deviceTypeId
            }
          ];
          this.$set(this.deviceList, index, data);
        });
      }
      this.eidtDialogVisible = true;
    },

    addStock(factoryType, activeType) {
      let layer = this.selectInfo.layer + 1;
      if (this.stockList.length == 0 && (factoryType == 4 || factoryType == 5)) {
        this.stockList.push({
          factoryType,
          layer
        });
      }
      if (this.materialStockList.length == 0 && factoryType == 7) {
        this.materialStockList.push({
          factoryType,
          layer
        });
      }
      this.$refs["edit"].clearValidate();
      this.activeType = activeType;
    },

    submitEdit() {
      this.$refs["edit"].validate(valid => {
        if (valid) {
          if (this.addForm.factoryType == 3) {
            this.addForm.deviceList = this.addForm.sonList;
          }
          if (this.addForm.factoryType == 6 || this.addForm.factoryType == 8) {
            this.addForm.factoryModelPositionList = this.addForm.sonList;
          }
          this.addForm.standardCycle = Number(this.addForm.standardCycle);
          let temp = this.addForm.standardCycle;
          if (this.addForm.timeType === 0) {
            this.addForm.standardCycle = 60 * 60 * this.addForm.standardCycle;
          } else if (this.addForm.timeType === 1) {
            this.addForm.standardCycle = 60 * this.addForm.standardCycle;
          }
          if (this.addForm.standardCycle && this.addForm.standardCycle > 24 * 60 * 60) {
            this.$message.warning("标准工时不能超过24小时");
            this.addForm.standardCycle = temp;
            return;
          }
          let id = this.addForm.id;
          this.$RequestUtil.post({
            url: "/api/factoryModel/updateFactoryModel",
            type: "sync",
            params: this.addForm,
            success: async res => {
              if (res.code == 0) {
                this.$message.success("修改成功");
                this.$store.commit("add_reloadPages", ["/MasterData/DeviceMgt", "/TechnologyBOM/TechnologyTemplate", "/TechnologyBOM/ProcedureMapWorkshop"]);
                await this.loadOrganizationData(id);
                this.cancelEditDialog();
              } else {
                this.addForm.standardCycle = temp;
                this.$message.error(res.msg || res.message);
              }
            }
          });
        }
      });
    },

    cancelEditDialog() {
      this.eidtDialogVisible = false;
      this.addForm = {
        name: null,
        parentId: null,
        id: null,
        oldName: null,
        newName: null,
        sonList: [],
        stockList: []
      };
      this.activeType = 1;
      this.editData = {};
    },

    deleteItem(data) {
      this.$confirm(`确认删除该组织节点吗?`, "提示", {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        this.$RequestUtil.post({
          url: "/api/factoryModel/deleteFactoryModelNode",
          type: "sync",
          params: {
            id: data.id
          },
          success: async res => {
            if (res.code == 0) {
              this.$message.success("删除成功");
              await this.loadOrganizationData(data.parentId);
              this.$store.commit("add_reloadPages", ["/MasterData/DeviceMgt"]);
            } else {
              this.$message.error(res.msg || res.message);
            }
          }
        });
      });
    },

    async handleNodeClick(ev) {
      this.selectId = ev.id;
      // 当点击编辑和删除的时候nodeClick++阻止节点click事件执行
      if (this.nodeClick > 1) {
        this.nodeClick = 1;
        return;
      }

      this.selectInfo = commonUtils.cloneObj(ev);
      log(this.selectInfo, 1234);
      if (!this.selectInfo.isResource && this.activeName == 2) {
        this.activeName = "0";
      }
      this.handleClick();
    },

    async loadListResource() {
      let { data, code, msg, message } = await this.$RequestUtil.getAsync({
        url: "/api/select/listResource",
        type: "sync",
        params: {}
      });
      if (code == 0) {
        this.listResource = data;
      } else {
        this.$message.error(msg || message);
      }
    },

    async loadDeviceListByProductionLineId(id, factoryName) {
      let { data, code, msg, message } = await this.$RequestUtil.getAsync({
        url: "/api/factoryModel/getFactoryModel",
        type: "sync",
        params: { id, factoryName }
      });
      if (code == 0) {
        return data;
      } else {
        this.$message.error(msg || message);
      }
    }
  },
  filters: {
    parseDate(ev) {
      if (ev) {
        return commonUtils.timestampToDate(ev);
      } else {
        return "";
      }
    },
    filterTime(ev) {
      return commonUtils.secondToDate(ev);
    }
  }
};
</script>
<style scoped>
.show-ellipsis {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
#factory-model {
  background: #f6f7fa;
  display: flex;
  margin: 2px 12px;
}
.left-store-nav {
  width: 580px;
  margin-right: 16px;
  background: #fff;
  padding-top: 20px;
}

.left-store-nav .tree-list {
  width: 560px;
  margin: 0 10px;
  /* border-bottom: 1px solid #ccc; */
}

.table-head {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  margin: 0 10px;
  border: 1px solid #ccc;
  width: 570px;
  padding-right: 8px;
  height: 34px;
}
.table-head-item {
  height: 34px;
  line-height: 34px;
  text-align: center;
  border-left: 1px solid #ccc;
}
.table-head-code {
  width: 174px;
}

@media screen and (min-width: 1900px) {
  #factory-model {
    height: 830px;
  }
  .left-store-nav {
    width: 600px;
  }
  .left-store-nav .tree-list {
    width: 580px;
  }
  .right-store-list {
    width: 84%;
  }
}

@media screen and (min-width: 1200px) and (max-width: 1899px) {
  #factory-model {
    height: 750px;
    width: 104%;
    padding-bottom: 16px;
  }
  .table-head {
    width: 450px;
  }
  .table-head-code {
    width: 134px;
  }
  .left-store-nav {
    width: 480px;
  }
  .left-store-nav .tree-list {
    width: 460px;
  }
}

.right-store-list {
  width: 84%;
  background: #fff;
  height: 100%;
}

#factory-model .title {
  color: #606266;
  font-family: NotoSansHans-Regula;
  font-size: 14px;
  display: inline-block;
  width: auto;
  text-align: right;
}
#factory-model .value {
  width: 188px;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}

.table_searchbar {
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
}
.import_upload {
  display: inline;
}

.delete {
  width: 18px;
  height: 19px;
  background-image: url("../../../static/img/del.png");
  cursor: pointer;
  background-repeat: no-repeat;
}
.delete:hover {
  background-image: url("../../../static/img/del-hover.png");
  background-repeat: no-repeat;
}
.qrcode_div {
  text-align: center;
}
</style>
<style>
#factory-model .el-tree-node__content {
  height: 34px;
  border: 1px solid #ccc;
  border-top: none;
}
#factory-model .el-dialog--center .el-dialog__body {
  padding: 19px 25px 20px;
}
#factory-model .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background: #409eff;
  color: #fff;
}
.select_device_width {
  width: 200px;
}
.show-ellipsis {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.table_searchbar .el-button--mini,
.el-button--mini.is-round {
  padding: 7px 10px;
}
.timer .el-time-panel {
  width: 140px;
  left: 6px;
}
@media screen and (min-width: 1900px) {
  #factory-model .left-store-nav .el-scrollbar__wrap {
    overflow-x: hidden;
    height: 806px;
    overflow-x: hidden;
    margin-bottom: 0px !important;
  }
}
@media screen and (min-width: 1400px) and (max-width: 1800px) {
  #factory-model .left-store-nav .el-scrollbar__wrap {
    overflow-x: hidden;
    height: 700px;
    overflow-x: hidden;
    margin-bottom: 0px !important;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1399px) {
  #factory-model .left-store-nav .el-scrollbar__wrap {
    overflow-x: hidden;
    height: 680px;
    overflow-x: hidden;
    margin-bottom: 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/FactoryModel/FactoryModel.vue